<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'EmptyView' //空容器组件 用来设置多级路由
}
</script>
